import React from "react";
import {Cell, Pie, PieChart, ResponsiveContainer, Tooltip} from "recharts";

import {colors} from "nxtconstants";
import {
  formatCurrency,
  formatPercent
} from "./CalculatorLogic";
import {
  ChartLayout,
  DataTable,
  DonutContainer,
  GPL_ACCENT,
  LegendBar,
  LegendContent,
  LegendPanel,
  LegendRow,
  LegendTitle,
  LegendValue,
  MobileSummaryBlock,
  MobileSummaryCard,
  MobileTabButton,
  MobileTabContainer,
  SummaryBlock,
  SummaryCard,
  SummaryLabel,
  SummarySuffix,
  SummaryValue,
  SummaryValueRow,
  TableWrapper,
  ViewToggleButton,
  ViewToggleContainer
} from "./CalculatorStyle";

export const MobileTabToggle = ({activeTab, onChange}) => (
  <MobileTabContainer>
    <MobileTabButton
      active={activeTab === "input"}
      type="button"
      onClick={() => onChange("input")}
    >
      Input
    </MobileTabButton>
    <MobileTabButton
      active={activeTab === "result"}
      type="button"
      onClick={() => onChange("result")}
    >
      Result
    </MobileTabButton>
  </MobileTabContainer>
);

export const SummaryCards = ({
  adjustedTarget,
  initialLumpsum,
  targetPeriod
}) => (
  <>
    <SummaryCard>
      <SummaryBlock>
        <SummaryLabel>To reach target of</SummaryLabel>
        <SummaryValueRow>
          <SummaryValue>{formatCurrency(adjustedTarget)}</SummaryValue>
          <SummarySuffix>in {targetPeriod} years</SummarySuffix>
        </SummaryValueRow>
      </SummaryBlock>
      <SummaryBlock>
        <SummaryLabel>You need to invest</SummaryLabel>
        <SummaryValueRow>
          <SummaryValue>{formatCurrency(initialLumpsum)}</SummaryValue>
          <SummarySuffix>One time</SummarySuffix>
        </SummaryValueRow>
      </SummaryBlock>
    </SummaryCard>

    <MobileSummaryCard>
      <MobileSummaryBlock>
        <SummaryLabel>To reach target of</SummaryLabel>
        <SummaryValueRow>
          <SummaryValue>{formatCurrency(adjustedTarget)}</SummaryValue>
          <SummarySuffix>in {targetPeriod} years</SummarySuffix>
        </SummaryValueRow>
      </MobileSummaryBlock>
      <MobileSummaryBlock>
        <SummaryLabel>you need to invest</SummaryLabel>
        <SummaryValueRow>
          <SummaryValue>{formatCurrency(initialLumpsum)}</SummaryValue>
          <SummarySuffix>One time</SummarySuffix>
        </SummaryValueRow>
      </MobileSummaryBlock>
    </MobileSummaryCard>
  </>
);

export const ViewToggle = ({activeView, onChange}) => (
  <ViewToggleContainer>
    <ViewToggleButton
      active={activeView === "graph"}
      type="button"
      onClick={() => onChange("graph")}
    >
      Graph
    </ViewToggleButton>
    <ViewToggleButton
      active={activeView === "table"}
      type="button"
      onClick={() => onChange("table")}
    >
      Table
    </ViewToggleButton>
  </ViewToggleContainer>
);

export const YearlyTable = ({yearlyData}) => (
  <TableWrapper>
    <DataTable>
      <thead>
        <tr>
          <th>Year</th>
          <th>Total Investment</th>
          <th>Gain</th>
          <th>Year End Wealth</th>
        </tr>
      </thead>
      <tbody>
        {yearlyData.map((row) => (
          <tr key={row.year}>
            <td>{row.year}</td>
            <td>{formatCurrency(row.totalInvested)}</td>
            <td>{formatCurrency(row.totalGain)}</td>
            <td>{formatCurrency(row.totalAmount)}</td>
          </tr>
        ))}
      </tbody>
    </DataTable>
  </TableWrapper>
);

export const DonutChartSection = ({
  totalInvested,
  totalGain,
  gainPercent,
  investedPercent,
  chartKey
}) => {
  const donutData = [
    {name: "Invested", value: totalInvested, fill: colors.primary},
    {name: "Gain", value: Math.max(totalGain, 0), fill: GPL_ACCENT}
  ];

  return (
    <ChartLayout>
      <DonutContainer>
        <ResponsiveContainer width="100%" height="100%" key={chartKey}>
          <PieChart>
            <Pie
              cx="50%"
              cy="50%"
              data={donutData}
              dataKey="value"
              innerRadius="58%"
              outerRadius="88%"
              paddingAngle={2}
              stroke="#ffffff"
              strokeWidth={2}
            >
              {donutData.map((entry) => (
                <Cell fill={entry.fill} key={entry.name} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => formatCurrency(value)} />
          </PieChart>
        </ResponsiveContainer>
      </DonutContainer>

      <LegendPanel>
        <LegendRow>
          <LegendBar color={GPL_ACCENT} />
          <LegendContent>
            <LegendTitle>Gain</LegendTitle>
            <LegendValue>
              {formatCurrency(totalGain)} ({formatPercent(gainPercent)})
            </LegendValue>
          </LegendContent>
        </LegendRow>
        <LegendRow>
          <LegendBar color={colors.primary} />
          <LegendContent>
            <LegendTitle>Invested</LegendTitle>
            <LegendValue>
              {formatCurrency(totalInvested)} ({formatPercent(investedPercent)})
            </LegendValue>
          </LegendContent>
        </LegendRow>
      </LegendPanel>
    </ChartLayout>
  );
};
